const state = {


    cart_id: null,
    cart_settings_id: null,

    refresh_key: 0,

    cartDetailDialog: false,
    cartSettingsDialog: false,
    cartPaymentRequestDialog: false,

    address_id: null,
    addressDetailDialog: false,
    
    tax_id: null,
    fee_id: null,
    discount_id: null,

    product_id: null,
    product_settings_id: false,

    metaDialog: false,

    showNotes: false,
    
    detailDialog: false,
    itemDetailDialog: false,
    taxDetailDialog: false,
    feeDetailDialog: false,
    discountDetailDialog: false,

    cartSelectDialog: false,
    cartSelectTaxesDialog: false,
    cartSelectFeesDialog: false,
    cartSelectDiscountsDialog: false,

    cartSelectProductDialog: false,

    closeSaveCart: false,


    labels: {}

};

const getters = {};

const mutations = {};

const actions = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
